module.exports = __webpack_public_path__ + "static/img/IMG_20240424_202203.f0107d65.jpg";